// Shared chart accents inspired by the dashboard color reference.
export const CHART_COLORS = {
  pink: "#FF2D78",
  teal: "#00B8A9",
  cyan: "#00A6C8",
  amber: "#FFAA1B",
  purple: "#A445B2",
};

export const CHART_PALETTE = Object.values(CHART_COLORS);
